// ===================== Object pool =====================
// Keeps a free list of reusable objects to avoid GC churn for the thousands
// of short-lived projectiles / enemies / gems the game creates.
export class Pool {
  constructor(factory, reset) {
    this.factory = factory;   // () => obj
    this.reset = reset;       // (obj) => void  (clears fields on reuse)
    this.free = [];
    this.active = [];         // live objects, iterated by the game
  }
  spawn() {
    const obj = this.free.pop() || this.factory();
    obj.dead = false;
    this.active.push(obj);
    return obj;
  }
  // Compact the active list, releasing anything flagged .dead back to the pool.
  // Uses swap-remove so it's O(n) with no allocation.
  sweep(onRelease) {
    const a = this.active;
    let w = 0;
    for (let i = 0; i < a.length; i++) {
      const o = a[i];
      if (o.dead) {
        if (onRelease) onRelease(o);
        if (this.reset) this.reset(o);
        this.free.push(o);
      } else {
        a[w++] = o;
      }
    }
    a.length = w;
  }
  clear() {
    for (const o of this.active) {
      if (this.reset) this.reset(o);
      this.free.push(o);
    }
    this.active.length = 0;
  }
  get count() { return this.active.length; }
}
